import {ResearchQuestionInterface} from "../interfaces/ResearchQuestion";
import TypeOriginQuestion from "../interfaces/TypeOriginQuestion";
import ValueSearch from "../interfaces/ValueSearch";

export const Initial_ValueResearch: ValueSearch = {
    dsValorPesquisa: 'Pontuação até 5 estrelas',
    vlrPesquisa: '5 estrelas',
    flHabilitado: true,
    vlrMinimo: 1,
    vlrMaximo: 5,
}

export const Initial_TypeOriginQuestion: TypeOriginQuestion = {
    dsTipoPergunta: "",
    flAtivo: true,
}

export const INITIAL_VALUES: ResearchQuestionInterface = {
    dsPesquisa: '',
    valoresPesquisa: '',
    flAtiva: true,
    flPadrao: '0',
    flNPS: false,
    idUsuario: '',
    idValoresPesquisa: Initial_ValueResearch,
    idTipoOrigemPergunta: Initial_TypeOriginQuestion
}